import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

// Cámaras instaladas fuera de la composición del kit: solo agregan fotos obligatorias (no tocan kit, catálogo ni inventario).
export const VmCameras = ({ wo, editable, onSaved }) => {
  const [cams, setCams] = useState(wo.extensions?.vvm?.cameras || []);
  const [cap, setCap] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get(`/work-orders/${wo.id}/evidence-rules`).then((r) => setCap(r.data.camera_capacity || null)).catch(() => {});
  }, [wo.id]);

  const set = (i, patch) => setCams((c) => c.map((x, idx) => (idx === i ? { ...x, ...patch } : x)));
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/work-orders/${wo.id}/vvm/cameras`, { cameras: cams });
      setCams(data.extensions?.vvm?.cameras || []);
      toast.success("Cámaras adicionales guardadas");
      onSaved?.();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };
  const atLimit = cap?.limit != null && cams.length >= cap.limit;

  return (
    <div className="space-y-2 rounded-lg border border-border p-3" data-testid="vm-cameras">
      <div className="text-sm font-semibold">Cámaras adicionales instaladas</div>
      {cap?.has_dashcam && (cap.limit != null
        ? <p className="text-xs text-muted-foreground" data-testid="vm-cameras-capacity">La Dashcam instalada admite {cap.limit} cámara(s) adicional(es).</p>
        : <p className="text-xs text-amber-400" data-testid="vm-cameras-capacity-unknown">Capacidad de cámaras no registrada en el Catálogo de equipos para este modelo. Verifica que el equipo admita las cámaras que agregas.</p>)}
      {cams.map((c, i) => (
        <div key={c.id || i} className="grid grid-cols-[1fr_1fr_auto] gap-2" data-testid={`vm-camera-${i}`}>
          <Input value={c.location} onChange={(e) => set(i, { location: e.target.value })} placeholder="Ubicación (obligatoria)" disabled={!editable} data-testid={`vm-camera-location-${i}`} />
          <Input value={c.model || ""} onChange={(e) => set(i, { model: e.target.value })} placeholder="Modelo (opcional)" disabled={!editable} data-testid={`vm-camera-model-${i}`} />
          {editable && <Button variant="ghost" size="icon" onClick={() => setCams((x) => x.filter((_, idx) => idx !== i))} data-testid={`vm-camera-remove-${i}`}><Trash2 className="h-4 w-4" /></Button>}
        </div>
      ))}
      {editable && (
        <div className="flex gap-2">
          <Button variant="outline" disabled={atLimit} onClick={() => setCams((x) => [...x, { location: "", model: "" }])} data-testid="vm-camera-add-button"><Plus className="mr-1 h-4 w-4" />Agregar cámara</Button>
          <Button onClick={save} disabled={saving || cams.some((c) => !c.location.trim())} data-testid="vm-cameras-save-button">Guardar cámaras</Button>
        </div>
      )}
    </div>
  );
};
